(() => {
  const PLACEHOLDER_LABEL = '必須オプション';
  const SELECT_BUTTON_LABEL = 'オプションを選択してください';

  const getProductForms = (productInfo) =>
    Array.from(productInfo.querySelectorAll('form[action*="/cart/add"]'));

  const getSubmitButton = (productInfo) => productInfo.querySelector('[id^="ProductSubmitButton-"]');

  const getPaymentButtons = (productInfo) => productInfo.querySelectorAll('.shopify-payment-button');

  const setSubmitState = (productInfo, isRequired) => {
    const submitButton = getSubmitButton(productInfo);
    if (!submitButton) return;

    const textNode = submitButton.querySelector('span');
    if (textNode && !submitButton.dataset.defaultText) {
      submitButton.dataset.defaultText = textNode.textContent.trim();
    }

    if (isRequired) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
      if (textNode) textNode.textContent = SELECT_BUTTON_LABEL;
    } else {
      submitButton.removeAttribute('aria-disabled');
      if (textNode && submitButton.dataset.defaultText) textNode.textContent = submitButton.dataset.defaultText;
    }
  };

  const setRequiredMode = (productInfo, isRequired) => {
    productInfo.classList.toggle('product-info--option-required', isRequired);

    getProductForms(productInfo).forEach((form) => {
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      if (isRequired) {
        if (!variantInput.dataset.defaultVariantId) {
          variantInput.dataset.defaultVariantId = variantInput.value;
        }
        variantInput.value = '';
        variantInput.setAttribute('disabled', 'disabled');
      } else {
        variantInput.removeAttribute('disabled');
      }
    });

    getPaymentButtons(productInfo).forEach((button) => {
      button.toggleAttribute('hidden', isRequired);
    });

    setSubmitState(productInfo, isRequired);
  };

  const hasSelection = (selects) => selects.every((select) => select.value !== '');

  const injectRequiredPlaceholder = (select) => {
    if (select.querySelector('option[data-required-placeholder]')) return;

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = PLACEHOLDER_LABEL;
    placeholder.disabled = true;
    placeholder.hidden = true;
    placeholder.dataset.requiredPlaceholder = 'true';

    select.prepend(placeholder);
    Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
    placeholder.selected = true;
    placeholder.setAttribute('selected', 'selected');
    select.selectedIndex = 0;
  };

  const initializeProductInfo = (productInfo) => {
    if (productInfo.dataset.requiredOptionInitialized === 'true') return;

    const variantSelects = productInfo.querySelector('variant-selects');
    const dropdowns = Array.from(productInfo.querySelectorAll('.product-form__input--dropdown select'));
    if (!variantSelects || dropdowns.length === 0) return;

    productInfo.dataset.requiredOptionInitialized = 'true';
    dropdowns.forEach(injectRequiredPlaceholder);
    setRequiredMode(productInfo, true);

    variantSelects.addEventListener('change', () => {
      if (!hasSelection(dropdowns)) {
        setRequiredMode(productInfo, true);
        return;
      }

      setRequiredMode(productInfo, false);
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll?.('product-info').forEach(initializeProductInfo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  window.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
